import { Component, OnInit, Input, ViewChild, inject } from "@angular/core";
import { StandingDataMapping } from "@constants/standingdatamapping";
import { StandingDataView } from "./standing-data-view";
import { StandingDataEditorComponent } from "./standing-data-editor/standing-data-editor.component";
import { StandingDataType } from "@enums/StandingDataType";
import {
    StandingDataOverviewType,
    GenericStandingDataConfig,
} from "@app/shared/models/GenericList/GenericStandingDataConfig";
import { StandingDataListViewComponent } from "./standing-data-list-view/standing-data-list-view.component";
import { StandingDataTreeViewComponent } from "./standing-data-tree-view/standing-data-tree-view.component";

@Component({
    selector: "standingdata-generic",
    templateUrl: "./standingdata-generic.component.html",
    styleUrls: ["./standingdata-generic.component.scss"],
    imports: [StandingDataListViewComponent, StandingDataTreeViewComponent, StandingDataEditorComponent]
})
export class StandingDataGenericComponent implements OnInit {
    private _sdMapping = inject(StandingDataMapping);

    @ViewChild("standingDataView") standingDataView: StandingDataView;
    @ViewChild("editCmp", { static: true }) editCmp: StandingDataEditorComponent;

    @Input() type: StandingDataType;
    @Input() name: string;

    loaded = false;

    componentConfig: GenericStandingDataConfig;
    overviewTypes = StandingDataOverviewType;
    originalEditComp: StandingDataEditorComponent;

    async ngOnInit() {
        this.componentConfig = this._sdMapping[this.type];
        this.loaded = true;
        this.originalEditComp = this.editCmp;
    }
}
